import I18nextLoader from '../modules/i18nextLoader';
//@ts-ignore
import * as translatePackageJson from '@louis/translations/package.json';
import { useTranslation } from "react-i18next";

const translate = function (text: string, textDomain?: string) {
    const availableTextDomains: string[] = translatePackageJson.louisTranslations.textDomains;
    if (availableTextDomains.includes(textDomain)) {
        return I18nextLoader.getInstance().t(text, {
            ns: textDomain,
        });
    }

    return text;
}

const translateSync = function (text: string, textDomain?: string) {
    const availableTextDomains: string[] = translatePackageJson.louisTranslations.textDomains;
    if (availableTextDomains.includes(textDomain)) {
        return useTranslation().t(text, {
            ns: textDomain,
        });
    }

    return text;
}

const translateReplace = function (
    text: string,
    replaces: [] | object,
    textDomain?: string
) {
    const availableTextDomains: string[] = translatePackageJson.louisTranslations.textDomains;
    if (availableTextDomains.includes(textDomain)) {
        return I18nextLoader.getInstance().t(text, {
            replace: replaces,
            ns: textDomain,
        });
    }

    return text;
}

const translateReplacePlural = function (
    text: string,
    count: number,
    replaces: [] | object = null,
    textDomain?: string,
    _locale?: string
) {
    return I18nextLoader.getInstance().t(text, {
        count,
        replace: replaces,
        ns: textDomain
    });
}

export {
    translate,
    translateSync,
    translate as defTranslate,
    translateReplace,
    translateReplace as defTranslateReplace,
    translateReplacePlural,
    translateReplacePlural as defTranslateReplacePlural,
};
